import { useState, useEffect, useCallback, useMemo } from "react";
import { useProjectApi } from "../../../hooks/useProjectApi";
import { useProjectDeliverableApi } from "../../../hooks/useProjectDeliverable.js";
import { useProjectMilestoneApi } from "../../../hooks/useProjectMilestone.js";
import { useParams } from "react-router-dom";
export const useAllDeliverableViewModel = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const projectId = useParams()?.id;
    const {
        getProjectDeliverables,
        createProjectDeliverable: apiCreateProjectDeliverable,
        updateProjectDeliverable: apiUpdateProjectDeliverable,
        deleteProjectDeliverable,
        getProjectDeliverablesByMilestoneId,
        cacheOperations: { readProjectDeliverables, writeProjectDeliverables },
    } = useProjectDeliverableApi();

    const {
        getProjectMilestones,
        getProjectMilestonesByProjectId,
        cacheOperations: { readProjectMilestones, writeProjectMilestones }
    } = useProjectMilestoneApi();

    const [milestoneId, setMilestoneId] = useState(0)
    const fetchSubData = async (row) => {
        const projectDeliverablesResult = await getProjectDeliverablesByMilestoneId(row);
        writeProjectDeliverables(projectDeliverablesResult?.data)
        return projectDeliverablesResult?.data
    }

    const fetchData = useCallback(async () => {
        if (loading) return;
        setLoading(true);
        try {
            const [projectMilestonesResult, projectDeliverablesResult] = await Promise.all([
                getProjectMilestones(),
                getProjectDeliverables()
            ]);

            if (!projectMilestonesResult.success || !projectDeliverablesResult.success) {
                throw new Error("Failed to fetch required data");
            }
            writeProjectMilestones(projectMilestonesResult.data);
            writeProjectDeliverables(projectDeliverablesResult.data)
        } catch (err) {
            setError(err.message);
            console.error("Error fetching data:", err);
        } finally {
            setLoading(false);
        }
    }, [getProjectMilestones, getProjectDeliverables, getProjectDeliverablesByMilestoneId, writeProjectDeliverables, loading]);

    // useEffect(() => {
    //     fetchData();
    // }, []);

    const handleCreateProjectDeliverable = useCallback(
        async (formData) => {
            try {
                const result = await apiCreateProjectDeliverable(formData);
                const projectMilestonesResult = await getProjectMilestonesByProjectId(projectId)

                if (!projectMilestonesResult.success) {
                    throw new Error("Failed to fetch required data");
                }
                writeProjectMilestones(projectMilestonesResult.data);
                writeProjectDeliverables(result.data)
                if (result.success) {
                    return { success: true };
                }
                throw new Error(result.error || "Failed to create project resource mapping");
            } catch (error) {
                console.error("Error creating  project resource mapping:", error);
                throw new Error(error.message);
            }
        },
        [apiCreateProjectDeliverable]
    );

    const handleUpdateProjectDeliverable = useCallback(
        async (projectDeliverable, formData) => {
            try {
                const result = await apiUpdateProjectDeliverable(projectDeliverable.deliverable_id, formData);
                const projectMilestonesResult = await getProjectMilestonesByProjectId(projectId)

                if (!projectMilestonesResult.success) {
                    throw new Error("Failed to fetch required data");
                }
                writeProjectMilestones(projectMilestonesResult.data);
                writeProjectDeliverables(result.data)
                if (result.success) {
                    // await fetchData()
                    return { success: true };
                }
                throw new Error(result.error || "Failed to update project resource mapping");
            } catch (error) {
                console.error("Error updating project resource mapping:", error);
                throw new Error(error.message);
            }
        },
        [apiUpdateProjectDeliverable]
    );

    const handleDelete = useCallback(
        async (projectDeliverable) => {
            try {
                const result = await deleteProjectDeliverable(projectDeliverable.deliverable_id);
                const projectMilestonesResult = await getProjectMilestonesByProjectId(projectId)

                if (!projectMilestonesResult.success) {
                    throw new Error("Failed to fetch required data");
                }
                writeProjectMilestones(projectMilestonesResult.data);
                writeProjectDeliverables(result.data)
                if (result.success) {
                    console.log("The delete of deliverable is success")
                    // await fetchData();
                } else {
                    setError(result.error);
                    throw new Error(error.message);
                }
            } catch (err) {
                setError(err.message);

                throw new Error(error.message);
            }
        },
        [deleteProjectDeliverable]
    );
    const getMilestoneName = useMemo(
        () => (projectId) => {
            const projects = readProjectMilestones();

            const project = projects.find(
                (project) => project.project_id.toString() === projectId?.toString()
            );

            return project?.project_name || "Unknown";
        },
        [readProjectMilestones]
    );


    return {
        // projectDeliverables: readProjectDeliverables(),
        milestones: readProjectMilestones(),
        loading,
        error,
        getMilestoneName,
        createProjectDeliverable: handleCreateProjectDeliverable,
        updateProjectDeliverable: handleUpdateProjectDeliverable,
        handleDelete,
        // refetchDeliverables: fetchData,
        fetchSubData
    };
};
